export const PAYMENT_METHOD = {
    CreditCard: "CreditCard",
    Cash: "Cash",
} as const;

export type PaymentMethodType = (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD];
